<template>
  <div class="terms">
    <span><span class="required">*</span> Required Field</span>
  </div>
</template>

<script>
  export default {name: 'terms'}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'

  .terms
    margin: 50px auto 0

    .required
      color: $color-error
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue